module.exports = __webpack_public_path__ + "static/media/hiclipart.com.5e9203c9.png";